export const {
  ORCHESTRATOR_BACKEND_HOST = '',
  SERVER_FETCH_DATA_TIMEOUT = 7000,
  USE_APPSFLYER,
  USE_CREDENTIALS,
  USE_REMOTES,
  LOG_LEVEL = 'error',
  API_KEY = 'api_key',
} = typeof process === 'undefined' ? ({} as NodeJS.ProcessEnv) : process.env;
